module.exports = __webpack_public_path__ + "img/new-consult4.1747ef82.png";